import type { Characteristics } from './heroes';
import type { Option } from './stories';

export const PERSON_KEYWORDS = [
  'boy',
  'girl',
  'man',
  'woman',
  'person',
  'child',
  'baby',
  'kid',
  'toddler',
  'teen',
] as const;

export const PERSON_TYPE_OPTIONS: Option[] = [
  { value: 'boy', label: 'Boy' },
  { value: 'girl', label: 'Girl' },
  { value: 'man', label: 'Man' },
  { value: 'woman', label: 'Woman' },
];

export function isPersonHero(chars: Characteristics | undefined): boolean {
  const type = chars?.type?.toLowerCase() ?? '';
  if (!type) return false;
  return PERSON_KEYWORDS.some((kw) => type.includes(kw));
}

export function inferPersonType(chars: Characteristics | undefined): string {
  const type = chars?.type?.toLowerCase() ?? '';
  for (const opt of PERSON_TYPE_OPTIONS) {
    if (type.includes(opt.value)) return opt.value;
  }
  if (type.includes('child') || type.includes('kid') || type.includes('baby') || type.includes('toddler')) {
    return 'boy';
  }
  return 'boy';
}
